/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/date/DateDiff.ts
 * @create:      2025-06-27 21:46:59.941
 * @modify:      2025-07-11 21:19:12.905
 * @version:     6.0.0
 * @times:       11
 * @lines:       50
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { DateTime } from "../class/DateTime";
import { TTimeUnit } from "../type/advanced";

/**
 * Calculates the difference between two dates in the specified time unit.
 *
 * @param date - The first date to compare.
 * @param anotherDate - The second date to compare.
 * @param unit - The unit of time to return the difference in (defaults to "milliseconds").
 * @returns The difference between the two dates in the specified unit.
 * 
 * @since 4.0.0
 * @version 2021-12-14
 */
export function DateDiff(date: Date, anotherDate: Date, unit: TTimeUnit = "milliseconds") {
    return DateTime.From(date).Diff(DateTime.From(anotherDate), unit);
}
